export var pathMatches = function (actual, expectedRegex) { return actual.search(expectedRegex) >= 0; };
